import { ENVIRONMENTS, getCurrentEnvironment } from "@/utils/common";

export const BRANCH_LINK = "https://4bmjx.app.link/creso-partner";

const REDIRECT_SESSION_KEY = "creso-partner-mobile-app-redirect";

export function shouldSkipMobileAppRedirect(pathname: string): boolean {
  if (getCurrentEnvironment() !== ENVIRONMENTS.PRODUCTION) {
    return true;
  }

  if (!/android|iphone|ipad|ipod/i.test(navigator.userAgent)) {
    return true;
  }

  if (
    pathname.startsWith("/set-password") ||
    pathname.startsWith("/mfd/") ||
    pathname.startsWith("/signup/distributor") ||
    pathname.startsWith("/welcome")
  ) {
    return true;
  }

  return false;
}

/** Redirect uninstalled mobile users to the app store via Branch (once per tab). */
export function scheduleMobileAppRedirect(pathname: string): () => void {
  if (shouldSkipMobileAppRedirect(pathname)) {
    return () => undefined;
  }

  const timer = setTimeout(() => {
    if (sessionStorage.getItem(REDIRECT_SESSION_KEY)) {
      return;
    }

    sessionStorage.setItem(REDIRECT_SESSION_KEY, "1");
    window.location.href = BRANCH_LINK;
  }, 0);

  return () => clearTimeout(timer);
}
